import { TenderTypes, type ConfigTender, type Tender } from '@centric-os/types';
import { DateTime } from 'luxon';

/** Unparseable hours (e.g. stored "Invalid DateTime") load as no time; an Invalid Date never equals itself and loops the tenders field array. */
const toRateTime = (time: string | undefined): Date | null => {
  const parsed = DateTime.fromFormat(time ?? '', 'HH:mm');
  return parsed.isValid ? parsed.toJSDate() : null;
};

/**
 * Maps config service tender to form state
 * @param {Partial<ConfigTender>} tender - The tender to map.
 * @returns {Tender} The mapped tender.
 */
export const mapTenderConfig = (tender: Partial<ConfigTender>): Tender => {
  const base_tender = {
    tender_number: tender.tender_number,
    name: tender.name,
  };
  if (tender.type === TenderTypes.MEAL_EQUIVALENT) {
    return {
      ...base_tender,
      type: TenderTypes.MEAL_EQUIVALENT,
      tax_exempt: tender.tax_exempt,
      id: tender.id,
      max_swipes_per_transaction: tender.max_swipes_per_transaction,
      rates: tender.rates.map((rate) => {
        const [startTime, endTime] = rate?.hours?.split('-') ?? [];
        return {
          amount: rate.amount / 100,
          startTime: toRateTime(startTime),
          endTime: toRateTime(endTime),
        };
      }),
    };
  }
  if (tender.type === TenderTypes.DECLINING_BALANCE) {
    return {
      ...base_tender,
      type: TenderTypes.DECLINING_BALANCE,
      id: tender.id,
      tax_exempt: tender.tax_exempt,
      ...(tender.stipend_split === true ? { stipend_split: true } : {}),
    };
  }
  if (tender.type === TenderTypes.MEAL_EXCHANGE) {
    return {
      ...base_tender,
      type: TenderTypes.MEAL_EXCHANGE,
      id: tender.id,
    };
  }
};
